import { render } from "./Home.vue?vue&type=template&id=89e3b5b2"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=89e3b5b2&lang=css"

import exportComponent from "C:\\Users\\tansi\\OneDrive\\Desktop\\all\\quitrent\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__